<template>
  <div id="new-contract" class="box" style="padding: 20px;">
    <vue-loading :active.sync="isSaving" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <transition name="fade" appear>
      <div>
        <h4>Add Contract</h4>
        <form id="accounts" @submit.prevent="addContract">
          <div class="form-group">
            <input type="text" style="max-width: 300px; margin-bottom: 10px;" class="form-control" id="contractname" placeholder="contract name" v-model="newContract" required>
            <button class="btn btn-primary">Add Contract</button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'ContractNew',
  components: {
    VueLoading
  },
  data () {
    return {
      newContract: null,
      isSaving: false
    }
  },
  methods: {
    addContract: function () {
      this.isSaving = true
      HTTP.post(`/management/contract/${this.newContract}`)
        .then(() => {
          this.flashMessage.success({
            message: 'Successfully created contract ' + this.newContract
          })
          this.isSaving = false
          this.$router.push({ name: 'ContractModify', params: { id: this.newContract } })
        })
        .catch((error) => {
          this.isSaving = false
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to create contract ' + this.newContract + ' : ' + msg
          })
        })
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/transitions.css'></style>



// WEBPACK FOOTER //
// src/views/ContractNew.vue